import { Auth } from 'aws-amplify'
import { IS_LOCAL } from '@/constants'
import store from '@/store'
import { getProvider } from '@/api'

const PROVIDER = process.env.VUE_APP_AWS_COGNITO_CUSTOM_PROVIDER

export const guardByHome = async (to, from, next) => {
  if (IS_LOCAL) {
    return next()
  }

  let provider
  const idpIdentifier = to.params.provider || PROVIDER
  try {
    provider = await getProvider({
      type: 'idp_identifier',
      value: idpIdentifier
    })
  } catch (err) {
    console.error(err)
    alert('不正なproviderが指定されました。')
    store.dispatch('unsetUser')
    await Auth.signOut()
    return next('/auth/sign-in')
  }

  try {
    const user = await checkAndStoreUser()
    if (user.providerName !== provider.oidc_provider_name) {
      console.error('not match provider.')
      return next(`/auth/federated-sign-in?provider=${idpIdentifier}`)
    }
    store.dispatch('setProvider', provider)
    return next()
  } catch (e) {
    console.error(e)
    store.dispatch('unsetUser')
    store.dispatch('unsetProvider')
    await Auth.signOut()
    return next('/auth/sign-in')
  }
}

export const handleSignOut = async (to, from, next) => {
  if (IS_LOCAL) {
    return next('/')
  }
  store.dispatch('unsetUser')
  await Auth.signOut()
  return next('/auth/sign-in')
}

export const handleFederatedSignIn = async (to, from, next) => {
  if (IS_LOCAL) {
    return next('/')
  }

  let provider
  try {
    provider = await getProvider({
      type: 'idp_identifier',
      value: to.query.provider || PROVIDER
    })
  } catch (err) {
    console.error(err)
    alert('不正なproviderが指定されました。')
    store.dispatch('unsetUser')
    await Auth.signOut()
    return next('/auth/sign-in')
  }

  try {
    const user = await checkAndStoreUser()
    if (user.providerName == provider.oidc_provider_name) {
      console.log('already signed')
      return next(`/${provider.idp_identifier}`)
    }
  } catch (err) {
    console.log(err)
  }
  console.log('to federated sign in....')

  try {
    await Auth.federatedSignIn({ customProvider: provider.oidc_provider_name })
  } catch (err) {
    console.error(err)
    store.dispatch('unsetUser')
    await Auth.signOut()
    return next('/auth/sign-in')
  }
}

export const handleIdpresponse = async (to, from, next) => {
  if (IS_LOCAL) {
    return next('/')
  }
  let count = 0
  const id = window.setInterval(async () => {
    if (count >= 10) {
      window.clearInterval(id)
      store.dispatch('unsetUser')
      await Auth.signOut()
      return next('/auth/sign-in')
    }
    try {
      const user = await checkAndStoreUser()
      const provider = await getProvider({
        type: 'provider_name',
        value: user.providerName
      })
      window.clearInterval(id)
      return next(`/${provider.idp_identifier}`)
    } catch (e) {
      console.error(e)
    }
    count++
  }, 1000)
}

async function checkAndStoreUser() {
  const authUser = await Auth.currentAuthenticatedUser()
  const payload = authUser
    .getSignInUserSession()
    .getIdToken()
    .decodePayload()

  const providerName = payload.identities[0].providerName || ''
  const user = {
    id: authUser.getUsername(),
    name: payload.name,
    picture: payload.picture,
    providerName: providerName
  }
  store.dispatch('setUser', user)

  return user
}
